import angular from 'angular';

import JuhuAutoAPIController from './juhu-auto.controller';

export default angular.module('autoboard.juhuAutoAPIComponent', [])
  .controller('JuhuAutoAPIController', JuhuAutoAPIController)
  .name;
